'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const PictureInPictureIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20.7999 19.2H11.7999C11.4999 19.2 11.2999 19 11.2999 18.7V13.7C11.2999 13.4 11.4999 13.2 11.7999 13.2H20.7999C21.0999 13.2 21.2999 13.4 21.2999 13.7V18.7C21.1999 19 20.9999 19.2 20.7999 19.2Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0499 13.95V18.45H20.5499V13.95H12.0499ZM10.9071 12.8072C11.1542 12.5601 11.4795 12.45 11.7999 12.45H20.7999C21.1204 12.45 21.4457 12.5601 21.6928 12.8072C21.9398 13.0543 22.0499 13.3796 22.0499 13.7V18.8217L22.0114 18.9372C21.9316 19.1765 21.802 19.4086 21.6178 19.5928C21.437 19.7736 21.1572 19.95 20.7999 19.95H11.7999C11.4795 19.95 11.1542 19.8399 10.9071 19.5928C10.66 19.3458 10.5499 19.0204 10.5499 18.7V13.7C10.5499 13.3796 10.66 13.0543 10.9071 12.8072Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M8.99995 14.4H3.19995C2.89995 14.4 2.69995 14.2 2.69995 13.9V5.19999C2.79995 4.99999 2.99995 4.79999 3.19995 4.79999H18.2C18.5 4.79999 18.7 4.99999 18.7 5.29999V11",
          stroke: "currentColor"
        }
      )
    ]
  }
);
const VpPictureInPictureIcon = forwardRef(PictureInPictureIcon);

export { VpPictureInPictureIcon as default };
